import AddIcon from '@mui/icons-material/Add';
import { Box, Container, Fab, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Table } from '../../../components/Table';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { useAppDispatch } from '../../../redux/hooks';
import { companySelector } from '../../../redux/modules/b2bThriftPlan/companies/company.selectors';
import { fetchDocumentType } from '../../../redux/modules/b2bThriftPlan/companies/company.actions';
import { locations } from '../../../routes/locations';

export const DocumentTypes = () => {
  const dispatch = useAppDispatch();
  const { documentTypes, documentTypesTotal, fetchDocumentTypeStatus } = useSelector(companySelector);
  const isLoading = fetchDocumentTypeStatus === fetchStatuses.pending;
  const navigate = useNavigate();
  const totalCount =
    typeof documentTypesTotal === 'number' && documentTypesTotal >= 0 ? documentTypesTotal : documentTypes?.length || 0;

  useEffect(() => {
    dispatch(fetchDocumentType());
  }, [dispatch]);

  const onAddNew = (): void => {
    navigate(locations.documentType('create'));
  };

  const columns = useMemo<GridColDef[]>(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        minWidth: 80,
      },
      {
        field: 'type',
        headerName: 'Type',
        minWidth: 200,
      },
      {
        field: 'createdAt',
        headerName: 'Created At',
        type: 'dateTime',
        minWidth: 180,
        valueGetter: (params) => (params.value ? new Date(params.value as string) : null),
      },
      {
        field: 'updatedAt',
        headerName: 'Updated At',
        type: 'dateTime',
        minWidth: 180,
        valueGetter: (params) => (params.value ? new Date(params.value as string) : null),
      },
    ],
    [],
  );

  return (
    <Container component="main" maxWidth="xl">
      <Box
        sx={{
          pb: 5,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'stretch', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 2, sm: 0 },
        }}
      >
        <Typography variant="h4">
          Document Types
          <Fab color="primary" size="small" aria-label="Create Document Type" onClick={onAddNew} sx={{ mx: 2 }}>
            <AddIcon />
          </Fab>
        </Typography>
      </Box>
      <Table columns={columns} rows={documentTypes ?? []} loading={isLoading} rowCount={totalCount} />
    </Container>
  );
};

export default DocumentTypes;
